module.exports = __webpack_public_path__ + "static/media/FE-FONT.66de053e.ttf";